define('v3/Pages/Check/Components/CheckClassGrid/CheckClassGrid.Component',[
	'jquery',
	'knockout',
	'lodash',
	'moment',
	'env',
	'v3/Common/Services/abilityGrowthService',
	'v3/Common/Services/frontend/Frontend.Service',
	'v3/Pages/Check/Services/Check.Service',
	'v3/Pages/Check/Components/CheckClassGrid/Services/checkClassGrid.Service',
	'text!v3/Pages/Check/Components/CheckClassGrid/CheckClassGrid.Component.html',
	'v3/Common/Models/enums',
	'v3/Common/Services/Frontend/Pupils.Service',
	'v3/Common/Bindings/SvgIcon.Binding',
	'v3/Common/Bindings/Mask.Binding',
	'v3/Common/Bindings/TriStateCheckbox.Bindings',
	'v3/Common/Bindings/Ellipsis.Binding',
	'v3/FromV2/utils'
], function ($, ko, _, moment, env, abilityGrowthService, frontend, checkService, checkClassGridService, htmlString, enums, pupilsService) {
	function CheckClassGrid (params) {
		var self = this;
		var _disposed = false;

		var _pupilsWithStatistics = ko.observable([]);

		self.enums = enums;
		self.env = env;
		self.isLoading = ko.observable(true);
		self.usePupilAverageGrowth = Settings.usePupilAverageGrowth || false;
		self.v4ReviewExperimentEnabled = Settings.usePupilAverageGrowth;

		self.selectedSubjectGroupId = params.subjectGroupId;
		self.selectedPeriod = params.period;
		self.selectedSubjectGroupItem = params.selectedSubjectGroupItem;
		self.includeSubdomains = ko.observable(false);
		self.reportData = ko.observable(null);
		self.pdfSelectionBarTitle = ko.computed(function () {
			var name = self.selectedSubjectGroupItem() ? self.selectedSubjectGroupItem().name : '';
			return Strings.PdfTrayTitleForSubjectGroup.formatRaw(name);
		});

		var defaultSortObject = {
			key: 'pupilNameForSorting',
			direction: enums.sortDirection.ascending
		};

		self.currentSortSetting = ko.observable(defaultSortObject);

		var selectedPeriodSubscription = self.selectedPeriod.subscribe(function (period) {
			var subjectGroupId = self.selectedSubjectGroupId();
			if (!subjectGroupId) {
				return;
			}

			self.isLoading(true);

			checkClassGridService.fillPupilsWithAbilityGrowth(_pupilsWithStatistics(), subjectGroupId, period, self.usePupilAverageGrowth)
				.done(function () {
					var arrayForRefresh = _pupilsWithStatistics();
					_pupilsWithStatistics([]);
					_pupilsWithStatistics(arrayForRefresh);

					self.isLoading(false);
				});
		});

		var selectedSubjectGroupSubscription = ko.computed(function () {
			var subjectGroupId = ko.unwrap(self.selectedSubjectGroupId);
			var period = self.selectedPeriod.peek();
			if (!subjectGroupId || _disposed) return;

			self.isLoading(true);
			checkClassGridService.getPupilsWithStatistics(subjectGroupId, period, self.usePupilAverageGrowth)
				.done(function (data) {
					_pupilsWithStatistics(data);
					self.isLoading(false);
				});
		});

		self.sortedGridData = ko.computed(function () {
			var direction = self.currentSortSetting().direction;
			var propertyName = self.currentSortSetting().key;

			if (propertyName === 'abilityGrowth') {
				return _.orderBy(_pupilsWithStatistics(), [
					function (x) {
						var score = (self.usePupilAverageGrowth)
							? x.score()
							: abilityGrowthService.getGrowthClass(x.actualGrowth(), x.expectedGrowth()).value;

						return score > 0 ? score : 0;
					},
					'pupilNameForSorting'
				], [
					direction,
					enums.sortDirection.ascending
				]);
			} else {
				return _.orderBy(_pupilsWithStatistics(), [propertyName], [direction]);
			}
		});

		self.goToPupilDetails = function (el) {
			checkService.goToPupilDetails(el.pupilId, self.selectedSubjectGroupId());
		};
		self.navigateToReportPage = function (el) {
			pupilsService.navigateToReportPage(el.pupilId, self.selectedSubjectGroupId());
		};
		self.dispose = function () {
			selectedSubjectGroupSubscription.dispose();
			selectedPeriodSubscription.dispose();
			self.sortedGridData.dispose();
			_disposed = true;
		};

		self.pdfReportIsLoading = ko.observable(false);
		self.pdfRenderReport = function () {
			self.pdfReportIsLoading(true);
			$('body').addClass('print-active');
			frontend.mask.show($('body'), { title: ko.observable(Strings.PdfLoadingStep2) });

			var chartsLoadedCount = 0;

			checkClassGridService.getPupilsReportData(self.selectedSubjectGroupId(), self.includeSubdomains())
				.then(function (abilities, percentiles, instructions) {
					var deferred = $.Deferred();

					if (abilities.length === 0) {
						frontend.notification.info(Strings.NoDataToShow);
						return deferred.reject('No data');
					}

					var reportData = {
						pupils: abilities.map(function (ability) {
							var pupilInfo = _.find(_pupilsWithStatistics(), { pupilId: ability.userId });

							pupilInfo.isRainBowChartLoaded.subscribe(function (loaded) {
								if (loaded) {
									chartsLoadedCount = chartsLoadedCount + 1;
								}

								if (chartsLoadedCount === _pupilsWithStatistics().length) {
									setTimeout(function () {
										deferred.resolve();
									}, 0);
								}
							});

							pupilInfo.userId = pupilInfo.pupilId;
							pupilInfo.name = pupilInfo.pupilName;

							var info = {
								pupilInfo: pupilInfo,
								ability: ability,
								subjectGroupInfo: self.selectedSubjectGroupItem(),
								percentiles: null
							};

							if (self.includeSubdomains()) {
								var pupilPercentiles = _.find(percentiles, { userId: ability.userId });
								if (pupilPercentiles) {
									var pupilInstructions = _.find(instructions, { userId: ability.userId });

									pupilPercentiles.subdomains = pupilPercentiles.subdomains.map(function (percentile) {
										var instructions = null;
										if (pupilInstructions) {
											var extraInstructionsForSubdomain = _.find(
												pupilInstructions.extraInstructionsCountPerSubdomain,
												{ subdomainId: percentile.subdomainId }
											);
											if (extraInstructionsForSubdomain) {
												instructions = extraInstructionsForSubdomain.extraInstructionsCount;
											}
										}

										percentile.extraInstructions = instructions;

										return percentile;
									});

									info.percentiles = pupilPercentiles;
								}
							}
							return info;
						})
					};

					self.reportData(reportData);

					fetch('/V4/log?token=' + localStorage.getItem('access_token'), {
						method: 'POST',
						body: JSON.stringify({ name: 'DownloadClassReport',
							classId: env.userInfo.classId,
							pupilIds: reportData.pupils.map(function (p) { return p.ability.userId; })
						})});

					return deferred;
				}).then(function () {
					var html = self.generateHTML();
					var deferred = $.Deferred();

					var currentRetryNumber = 0;
					var maxRetries = 3;

					// Due to some errors in the printing service this retry mechanism will try to generate the report again in case of an error.
					var generateReport = function (input) {
						var stringifiedInput;

						try {
							stringifiedInput = JSON.stringify(input);
						} catch (err) {
							deferred.reject();
							return;
						}

						checkClassGridService.generateReport(stringifiedInput)
							.then(function (data) {
								deferred.resolve(data);
							})
							.fail(function () {
								currentRetryNumber++;

								if (currentRetryNumber <= maxRetries) {
									generateReport(input);
								} else {
									deferred.reject();
								}
							});
					};

					generateReport(html);

					return deferred;
				}).then(function (base64Report) {
					var fileName = Strings.PdfFileName.formatRaw(self.selectedSubjectGroupItem().name, moment().format('L').replace(/\//g, '-')) + '.pdf';

					if (window.top.navigator.msSaveOrOpenBlob) {
						// Download PDF in IE/Edge by converting it to a Blob first
						var reportBlob = self.b64toBlob(base64Report, 'application/pdf');
						window.top.navigator.msSaveOrOpenBlob(reportBlob, fileName);
					} else {
						var linkSource = 'data:application/pdf;base64,' + base64Report;
						var downloadLink = document.createElement('a');

						downloadLink.href = linkSource;
						downloadLink.download = fileName;
						downloadLink.click();
					}
				})
				.always(function () {
					self.pdfReportIsLoading(false);
					frontend.mask.hide($('body'));
					$('body').removeClass('print-active');
				});
		};

		self.b64toBlob = function (b64Data, contentType) {
			var sliceSize = 512;
			var byteCharacters = atob(b64Data);
			var byteArrays = [];

			for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
				var slice = byteCharacters.slice(offset, offset + sliceSize);

				var byteNumbers = [];
				for (var i = 0; i < slice.length; i++) {
					byteNumbers[i] = slice.charCodeAt(i);
				}

				// eslint-disable-next-line
				var byteArray = new Uint8Array(byteNumbers);
				byteArrays.push(byteArray);
			}

			var blob = new Blob(byteArrays, { type: contentType });
			return blob;
		};

		self.generateHTML = function () {
			var config = {
				searchElements: {
					html: 'html',
					body: 'body',
					script: 'script',
					style: 'style',
					clazz: 'class',
					link: 'link',
					linksToRemove: ['Assets/sendbird.css']
				},
				classes: {
					html: 'showPrintPage class-report',
					clone: 'printable-page printable-page-clone'
				},
				container: {
					selector: '.printable-page'
				}
			};

			// clone html page
			var page = $(config.searchElements.html).clone();
			page.addClass(config.classes.html);

			// remove all script tags
			var scripts = page.find(config.searchElements.script);
			var i = scripts.length;
			while (i--) {
				scripts[i].parentNode.removeChild(scripts[i]);
			}

			// remove all style tags
			var styles = page.find(config.searchElements.style);
			var j = styles.length;
			while (j--) {
				styles[j].parentNode.removeChild(styles[j]);
			}

			// remove not needed link tags
			var links = page.find(config.searchElements.link);
			var k = links.length;
			while (k--) {
				var element = _.find(config.searchElements.linksToRemove, function (key) {
					return links[k].href.includes(key);
				});

				if (element) {
					links[k].parentNode.removeChild(links[k]);
				}
			}

			// empty body
			page.find(config.searchElements.body).html('');

			// attach content to body
			$(config.container.selector)
				.clone()
				.attr(config.searchElements.clazz, config.classes.clone)
				.appendTo(page.find(config.searchElements.body));

			var url = window.location.origin;
			if (url.indexOf('localhost') >= 0 || url.indexOf('-eb-dashboard.snappet.org') >= 0) {
				url = 'https://master-dashboard.snappet.org';
			}

			// fix line breaks and relative paths
			var text = page.get(0).outerHTML
				.replace(/\u21b5/g, '')
				.replace(/(\r\n|\n|\r)/g, '')
				.replace(/\n|\t/g, '')
				.replace(/\/Areas\/V3\//g, url + '/Areas/V3/');

			return text;
		};
	}

	return { viewModel: CheckClassGrid, template: htmlString };
});
